import { render, staticRenderFns } from "./StudentBio.vue?vue&type=template&id=cc34d90a&"
import script from "./StudentBio.vue?vue&type=script&lang=js&"
export * from "./StudentBio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports